<!-- Menu + header -->
<app-menu *ngIf="exibindoComponentes()"></app-menu>

<!-- content-->
<div [ngStyle]="{'padding-top': !(router.url === '/login' || router.url.substring(0, 11) === '/nova-senha') ? '70px' : '0px'}">

<!-- Application Loading -->
<ng-http-loader debounceDelay="300" backgroundColor="#5D9CEC" ></ng-http-loader>
 <div>
    <router-outlet></router-outlet>
</div>

<!-- footer-->
<app-footer *ngIf="exibindoComponentes()"></app-footer>
